import React from "react";
import "./Header.scss";

const Header = () => {
  return <h1 className="header">Ultimate Team App</h1>;
};

export default Header;
